import styled from "styled-components";

export const GameJackpotBarWrapperDefaultBox = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 4.8rem;
    padding: 0.3rem 0.8rem;    
    background-color: ${({theme}) => theme.colors.backgroundDark};
`;